module.exports = __webpack_public_path__ + "static/media/BillWallet.25bafc39.svg";